import { VIEWPORT } from "@/util/constants.ts";

export interface ViewportDimensions {
  w: number;
  h: number;
}

function isPortrait({ w, h }: ViewportDimensions) {
  return w < h;
}

function isMobilePortrait({ w, h }: ViewportDimensions) {
  return w < VIEWPORT.sm && h < VIEWPORT.md;
}

function isMobileLandscape({ w, h }: ViewportDimensions) {
  return w < VIEWPORT.md && h < VIEWPORT.sm;
}

function isMobileAny({ w, h }: ViewportDimensions) {
  return isMobileLandscape({ w, h }) || isMobilePortrait({ w, h });
}

function isDesktop({ w, h }: ViewportDimensions) {
  return !isMobileAny({ w, h });
}

export {
  isDesktop,
  isMobileAny,
  isMobilePortrait,
  isMobileLandscape,
  isPortrait,
};
